import { HTMLTagRenderer } from "~/util/HTMLTagRenderer"
import Button from "../Button"
import LightBulbIcon from "~/images/light-bulb.svg"
import { ISurveyExplainerData } from "~/types/dataTypes"
import Icon from "../Icon"

export interface SurveyExplainerProps
  extends React.HTMLAttributes<HTMLDivElement> {
  explainer: ISurveyExplainerData
}
export default function SurveyExplainer(
  props: SurveyExplainerProps
): JSX.Element {
  const { intro, instructions, tip } = props.explainer

  return (
    <div className="flex flex-col items-center lg:items-start justify-center lg:justify-self-center lg:self-center px-4 pb-14 pt-8 gap-8 lg:w-[660px] bg-primary-900">
      <div className="flex flex-grow flex-col gap-8 self-center text-center justify-center">
        <HTMLTagRenderer
          string={intro}
          className="font-serif text-2xl font-semibold text-white"
        />
        <HTMLTagRenderer
          string={instructions}
          className="text-base font-sans text-primary-300"
        />
        {tip && (
          <div className="flex gap-2 items-center p-2 bg-neutral-300 rounded-2xl">
            <img src={LightBulbIcon} alt="Question Icon" />
            <p className="text-sm">{tip}</p>
          </div>
        )}
      </div>
      <div className="flex w-full">
        <Button type="submit" variant="basic" className="w-full">
          <span className="flex justify-between">
            Fortsæt
            <Icon name="arrowRight" className="w-6 h-6 text-inherit" />
          </span>
        </Button>
      </div>
    </div>
  )
}
